import { action, observable } from "mobx";

/**
 * Per-object counter used to force React remounts of 3D/2D meshes after an
 * opacity restore. Not persisted — only needs to survive the current session
 * so corrupted Three.js material clones are discarded.
 */
export const opacityRemountEpochs = observable.map<string, number>();

export const getOpacityRemountEpoch = (objectId: string): number =>
  opacityRemountEpochs.get(objectId) ?? 0;

export const bumpOpacityRemountEpoch = action((objectId: string): number => {
  const next = getOpacityRemountEpoch(objectId) + 1;
  opacityRemountEpochs.set(objectId, next);
  return next;
});
